/* GR-P1008-RECOS (Claude 2026-10-08): "Close to this | Recently viewed" on the product page "You may also like" row.
   The theme already saves every opened product id in localStorage "theme:recently-viewed-products" (newest first,
   sections/main-product.liquid). Once 4 OTHER perfumes are in it, the 4 most recent are fetched as ready cards
   through the Section Rendering API (sections/gr-related.liquid has a search branch for this) and the row title
   becomes two tabs. Fetched once, early and at low priority, so a tap switches instantly. Fewer than 4 cards back
   (deleted or unpublished products): nothing changes, an empty or half tab never shows.
   Loaded by sections/gr-related.liquid itself (product pages with the row only); the tab CSS is in that file too.
   Safe to load twice: the box.__grRv flag makes the second run a no-op. */
(function () {
  var box = document.querySelector('[data-gr-rv]');
  if (!box || box.__grRv) return;
  box.__grRv = true;
  var me = parseInt(box.getAttribute('data-gr-rv'), 10);
  var ids = [];
  try { ids = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]'); } catch (e) { return; }
  if (!Array.isArray(ids)) return;
  var others = [], seen = {};
  for (var i = 0; i < ids.length; i++) {
    var n = parseInt(ids[i], 10);
    if (n && n !== me && !seen[n]) { seen[n] = 1; others.push(n); }
  }
  if (others.length < 4) return;

  var tabs = box.querySelector('.gr-rv__tabs');
  var tab = box.querySelectorAll('.gr-rv__tab');
  var panel = box.querySelectorAll('.gr-rv__panel');
  var h = box.querySelector('.gr-rv__h');
  if (!tabs || tab.length !== 2 || panel.length !== 2) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var q = others.slice(0, 8).map(function (x) { return 'id:' + x; }).join(' OR ');
  var url = root + 'search?type=product&q=' + encodeURIComponent(q) + '&section_id=gr-related';

  // review fix: the four Recently viewed pictures are only fetched once the row comes within about 1.5 viewports
  // (one observer, disconnected after it fires), so a visitor who never scrolls to the foot never loads them,
  // and the tap still shows them at once.
  var warmed = false, io = null;
  function warm() {
    if (warmed) return;
    warmed = true;
    if (io) { io.disconnect(); io = null; }
    panel[1].querySelectorAll('img[data-gr-src], img[data-gr-srcset]').forEach(function (img) {
      img.loading = 'eager';
      ['srcset', 'src'].forEach(function (a) {
        var v = img.getAttribute('data-gr-' + a);
        if (v !== null) { img.setAttribute(a, v); img.removeAttribute('data-gr-' + a); }
      });
    });
  }

  function select(k, focus) {
    if (k === 1) warm();
    for (var j = 0; j < 2; j++) {
      var on = j === k;
      tab[j].setAttribute('aria-selected', on ? 'true' : 'false');
      tab[j].tabIndex = on ? 0 : -1;
      panel[j].hidden = !on;
    }
    if (focus) tab[k].focus();
  }

  function build(cards) {
    var list = panel[1].querySelector('product-list');
    if (!list) return;
    var frag = document.createDocumentFragment();
    for (var c = 0; c < cards.length && c < 4; c++) {
      // Cards rendered through the Section Rendering API have no section.index, so product-card gives positions
      // 1 to 6 no loading attribute (= eager): they would start downloading the moment they are imported, and
      // even loading="lazy" did not stop Chromium fetching a picture whose URL is already on the page (measured).
      // So the picture URLs are parked here, in the inert parsed document, and warm() puts them back near the row.
      cards[c].querySelectorAll('img').forEach(function (img) {
        ['srcset', 'src'].forEach(function (a) {
          if (img.hasAttribute(a)) { img.setAttribute('data-gr-' + a, img.getAttribute(a)); img.removeAttribute(a); }
        });
      });
      frag.appendChild(document.importNode(cards[c], true));
    }
    list.replaceChildren(frag);
    // search links carry ?_pos=&_sid=&_ss= (search analytics); these cards are not a search
    list.querySelectorAll('a[href]').forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), location.href);
        if (!u.searchParams.has('_pos') && !u.searchParams.has('_sid')) return;
        ['_pos', '_sid', '_ss'].forEach(function (p) { u.searchParams.delete(p); });
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    });

    tabs.setAttribute('role', 'tablist');
    if (h) tabs.setAttribute('aria-label', h.textContent.trim());
    for (var j = 0; j < 2; j++) {
      tab[j].setAttribute('role', 'tab');
      panel[j].setAttribute('role', 'tabpanel');
      panel[j].setAttribute('aria-labelledby', tab[j].id);
      (function (k) { tab[k].addEventListener('click', function () { select(k, false); }); })(j);
    }
    tabs.addEventListener('keydown', function (e) {
      var cur = tab[1].getAttribute('aria-selected') === 'true' ? 1 : 0;
      var rtl = getComputedStyle(tabs).direction === 'rtl';
      var next = null;
      if (e.key === 'ArrowRight') next = rtl ? cur - 1 : cur + 1;
      else if (e.key === 'ArrowLeft') next = rtl ? cur + 1 : cur - 1;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = 1;
      if (next === null) return;
      e.preventDefault();
      select((next + 2) % 2, true);
    });
    select(0, false);
    tabs.hidden = false;
    box.classList.add('is-tabs');
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (en) {
        for (var e = 0; e < en.length; e++) if (en[e].isIntersecting) { warm(); return; }
      }, { rootMargin: '1200px 0px' });
      io.observe(box);
    } else warm();
  }

  function load() {
    var opts = { credentials: 'same-origin' };
    try { opts.priority = 'low'; } catch (e) {}
    fetch(url, opts).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.querySelector('.gr-rv-src');
      var cards = src ? src.children : [];
      if (cards.length >= 4) build(cards);
    }).catch(function () {});
  }
  if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 2500 }); else setTimeout(load, 600);
})();
